import React, { Component } from 'react';

import moment from 'moment';

import { isEmptyObject, numberToArray } from '../../../../../utils/utils';
import NowDatePicker from '../../../../../components/Common/NowDatePicker';
import NowSelect from '../../../../../components/Common/NowSelect';
import { trans } from '../../../../../localization/index';

function AddMinute({ value,onClick }) {
  return (
    <button className="btn btn-white btn-add-time" onClick={() => onClick(value)}>
      [{value} {trans('mod_detail_minute')}]
    </button>
  );
}

class DateTimePick extends Component {
  minutesOptions = numberToArray(60).map(minute => ({
    value: minute,
    label: minute,
  }));
  hourOptions = numberToArray(24).map(hour => ({
    value: hour,
    label: hour,
  }));

  handleUpdateHour = (hour) => {
    const { onChange, value } = this.props;
    if (!isEmptyObject(hour)) {
      onChange(
        moment(value)
          .set({ hour: hour.value })
          .toDate(),
      );
    }
  };

  handleUpdateMinute = (minute) => {
    const { onChange, value } = this.props;
    if (!isEmptyObject(minute)) {
      onChange(
        moment(value)
          .set({ minute: minute.value })
          .toDate(),
      );
    }
  };

  handleUpdateDay = (date) => {
    const { value, onChange } = this.props;
    const hour = moment(value).hours();
    const minute = moment(value).minutes();
    const newDate = moment(date).set({ hour, minute });
    onChange(newDate.toDate());
  };

  handlePlusTime = (minute) => {
    const { onChange, value } = this.props;
    onChange(
      moment(value)
        .add(minute, 'minutes')
        .toDate(),
    );
  };

  render() {
    const { value, isPickup } = this.props;
    const hour = moment(value).hours();
    const hourValue = {
      value: hour,
      label: hour,
    };
    const minute = moment(value).minutes();
    const minuteValue = {
      value: minute,
      label: minute,
    };

    const ranTimePlus = [15, 30, 45, 60];
    const descriptionPickTime = isPickup
      ? 'mod_detail_order_time_pickup'
      : 'mod_detail_restaurant_appointment_shipper';

    return (
      <div className="time-pick-wrap">
        <div className="range-time-pick">
          <strong>{trans(descriptionPickTime)}</strong>
          <NowDatePicker
            className="option-date"
            value={value}
            onChange={date => this.handleUpdateDay(date[0])}
          />
          {trans('mod_detail_at')}
          <NowSelect
            className="option-time"
            value={hourValue}
            options={this.hourOptions}
            isClearable={false}
            onChange={this.handleUpdateHour}
            width="90px"
          />
          {trans('mod_detail_hour')}
          <NowSelect
            className="option-time"
            value={minuteValue}
            options={this.minutesOptions}
            isClearable={false}
            onChange={this.handleUpdateMinute}
            width="90px"
          />
          {trans('mod_detail_minute')}
        </div>
        <div className="plus-pick-time">
          {ranTimePlus.map(time => (
            <AddMinute
              key={time}
              value={time}
              onClick={() => this.handlePlusTime(time)}
            />
          ))}
        </div>
      </div>
    );
  }
}
export default DateTimePick;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/DateTimePick.jsx